/*
 * 维护单业务公共逻辑（头部 / 中部 / 尾部共用）
 * - 常量、条件判断、通用保存（update / input_update）
 * - faceSection：人脸识别 + 资质识别区块（头部 face_* 与尾部 face_*_end 复用同一实现）
 * - scanner：扫码结果只读展示 + 扫码按钮（对应平台 Scanner，值为字符串）
 */
export default function installBiz(MW, host) {
  var h = MW.h;
  var ui = MW.ui;
  var util = MW.util;
  var store = MW.store;
  var api = MW.api;

  var biz = (MW.biz = {
    COMPARING: "正在比对人脸信息，请勿提交...",
    SCAN_FAIL: "匹配失败，请重新扫码，或者上传设备照片及设备二维码照片",
    TXT_START: "点击【开始维护】记录开始时间",
    TXT_END: "点击【确认完成】记录结束时间",
    PHOTO_TIME_EMPTY: "记录照片上传时间",

    v: function (k) {
      return store.get(k);
    },
    ctx: function () {
      return store.get("$context") || {};
    },
    user: function () {
      return biz.ctx().user;
    },
    isSelf: function () {
      return store.get("maintenance_process_type") === "自建";
    },
    isLease: function () {
      return store.get("maintenance_process_type") === "租赁";
    },
    isWeak: function () {
      return store.get("professional") === "弱电";
    },
    /** 服务商 + 随工类型 2 时需先在随工单激活子单 */
    needSubStart: function () {
      return store.get("to_maintainer") === "服务商" && String(store.get("overseer_type")) === "2";
    },
    /** 工单已结束（提交/取消后）或表单被平台置为只读/禁用状态 */
    isEnded: function () {
      var s = biz.ctx().ticketStatus;
      return s === "END" || s === "CANCEL" || !!(host.readonly && host.readonly());
    },
    /** 组件整体只读：工单已结束，或当前账号不是待办处理人 / 流程管理员 */
    isClosed: function () {
      return biz.isEnded() || biz.noPerm();
    },
    ticketId: function () {
      return biz.ctx().ticketId || store.get("ticket_id") || "";
    },
    steps: function () {
      return store.get("main_step") || [];
    },
    scanFailed: function () {
      var r = String(store.get("scan_code_result") || "");
      return r.indexOf("匹配失败") > -1 || r.indexOf("重新扫码") > -1;
    },
    showUploadStart: function () {
      return biz.isSelf() ? biz.scanFailed() || biz.isWeak() : true;
    },
    /** 维护准备是否完成（原 sw_start 可编辑条件 condition_1 自建 / condition_2 租赁，去掉开关自身状态部分） */
    prepareDone: function () {
      var v = biz.v, scan = v("scan_code_result");
      if (biz.isSelf()) {
        return v("face_detect_result") !== biz.COMPARING && !!v("sub_ticket_check_in") && !util.isEmpty(v("face_photo")) &&
          ((scan !== biz.SCAN_FAIL && !!scan) || (scan === biz.SCAN_FAIL && !util.isEmpty(v("upload_start"))) || biz.isWeak());
      }
      return !!v("sub_ticket_check_in") && !util.isEmpty(v("upload_start"));
    },
    /** sw_start 可编辑：未结单 && 未确认完成 && 维护准备完成 && 第一步未开始 */
    swStartEditable: function () {
      if (biz.isClosed()) return false;
      var ms0 = biz.steps()[0] || {};
      return !store.get("sw_end") && biz.prepareDone() && !ms0.step_start_sw;
    },
    allStepsTimed: function () {
      var ms = biz.steps();
      return ms.length > 0 && ms.every(function (s) { return s.step_start_time && s.step_end_time; });
    },
    /** 检查清单中的异常项数量（由当前中部组件的适配器统计） */
    countAbnormal: function () {
      return biz.mid.abnormalCount();
    },
    /** 检查清单中的异常项明细 [{ sn, title, desc }] */
    abnormalList: function () {
      return biz.mid.abnormalList() || [];
    },
    /** 已开始维护（头部人脸 / 设备核对据此锁定） */
    started: function () {
      return !!biz.mid.started();
    },
    /** 开始维护时间 */
    startTime: function () {
      return biz.mid.startTime() || "";
    },
    /** 检查清单全部完成（尾部【确认完成】据此放开） */
    allDone: function () {
      return !!biz.mid.allDone();
    },

    /** 旧版整表保存（已不再使用：多人同时操作时会互相覆盖，改为 MW.sync 按项保存） */
    update: function () {
      return api.call("update", { process_data: store.values, process_user: biz.user() });
    },
    /** 保存一个顶层字段（经 sync_patch 按项合并写入，记录操作人） */
    inputUpdate: function (id, value) {
      if (MW.sync) return MW.sync.save(id, arguments.length > 1 ? { value: value } : {});
      return api.call("input_update", { self_value: value, self_id: id });
    },
    /** 记录滚动位置（原 step_start_sw / step_end_sw 中的 last_position 逻辑） */
    saveLastPosition: function () {
      sessionStorage.setItem("last_position", util.scrollY());
      var lp = sessionStorage.getItem("last_position");
      if (lp) {
        store.set("last_position", lp, { silent: true });
        if (!MW.net.offline) api.call("input_update", { self_value: lp, self_id: "last_position" }).catch(function () {});
      }
    },
    /** 最后一次操作的控件（data-key），按工单保存在本机，供"回到上次填写的位置"精确定位到检查项 */
    saveAnchor: function (key) {
      try { localStorage.setItem("mw_anchor_" + biz.ticketId(), key); } catch (e) {}
    },
    lastAnchor: function () {
      try { return localStorage.getItem("mw_anchor_" + biz.ticketId()) || ""; } catch (e) { return ""; }
    },
    /** 工单跳转链接（原 Link 组件 href 表达式） */
    ticketUrl: function (id) {
      if (!id) return "";
      var k = util.hostKind();
      var t = util.isTestEnv() ? ".test" : "";
      if (k === "woa") return "https://dcops" + t + ".woa.com/operateManage/business/ToDoDetails?params=" + id;
      if (k === "tencent") return "https://dcops" + t + ".tencent.com/operateManage/business/details?params=" + id;
      return "";
    },
  });

  /**
   * 中部适配器：头部 / 尾部只通过这组接口了解检查清单的状态，
   * 不同工单的中部组件（通用检查清单 / 柴发等定制检查项）各自提供实现，头尾组件无需修改。
   *   started()       已开始维护
   *   startTime()     开始维护时间
   *   allDone()       检查清单全部完成
   *   abnormalCount() 异常项数量
   *   abnormalList()  异常项清单 [{ sn, title, desc }]（尾部确认异常项数量时展示）
   *   stepText()      检查清单进度的说明文案
   *   keys()          需要回填 / 多人同步的流程变量
   *   labels          同步提示中的中文名 { 变量名: 名称 }
   */
  function joinVals(x) { return [].concat(x == null ? [] : x).filter(function (t) { return !util.isEmpty(t); }).join("、"); }
  biz.joinVals = joinVals;
  var DEFAULT_MID = {
    name: "middle",
    started: function () { return !!store.get("sw_start"); },
    startTime: function () { return store.get("txt_start"); },
    allDone: function () { return biz.allStepsTimed(); },
    abnormalCount: function () { return biz.mid.abnormalList().length; },
    abnormalList: function () {
      var list = [];
      biz.steps().forEach(function (ms, i) {
        (ms.sub_step || []).forEach(function (s, j) {
          if ((s.r1 || "") !== "异常" && (s.r2 || "") !== "异常") return;
          list.push({
            sn: (ms.step_sn || i + 1) + "." + (s.sub_step_sn || j + 1),
            title: String(s.t1 || "").trim(),
            desc: [joinVals(s.a1), joinVals(s.i1)].filter(Boolean).join("："),
          });
        });
      });
      return list;
    },
    stepText: function () { return biz.steps().length + " 个步骤"; },
    keys: function () { return []; },
    labels: {},
  };
  biz.mid = DEFAULT_MID;
  /** 选用中部组件的适配器（缺省项沿用通用检查清单的实现） */
  biz.useMiddle = function (adapter) {
    biz.mid = adapter ? Object.assign({}, DEFAULT_MID, adapter) : DEFAULT_MID;
  };

  /**
   * 步骤折叠（各中部组件共用）
   * 默认规则：PC 全部展开；手机只展开未结束的步骤（已结束的自动收起）。手动 / 批量操作优先于默认规则，
   * 某步骤的状态置回 undefined 即恢复默认规则（如结束步骤、开始下一步时收起上一步）。
   * 中部组件：var fold = biz.folder(collapsed, list)，list() -> [{ id, started, ended }]；
   *   渲染时用 fold.is(id, ended) 判断是否折叠，并在 biz.part 中声明 fold，右上角"全部展开 / 收起"按钮即自动生效。
   */
  biz.autoFold = function (ended) { return !!ended && util.isMobileView(); };
  biz.folder = function (collapsed, list) {
    var ctl = {
      is: function (id, ended) { return collapsed[id] === undefined ? biz.autoFold(ended) : !!collapsed[id]; },
      /** 已开始（有检查项可折叠）的步骤数 / 其中展开的步骤数 */
      state: function () {
        var s = list().filter(function (x) { return x.started; });
        return { total: s.length, open: s.filter(function (x) { return !ctl.is(x.id, x.ended); }).length };
      },
      setAll: function (open) {
        list().forEach(function (x) { if (x.started) collapsed[x.id] = !open; });
      },
    };
    return ctl;
  };

  /**
   * 定义一个可挂载的维护单组件（头部 / 中部 / 尾部共用）
   * def.middle      中部组件的适配器（见 biz.useMiddle），平台挂载该组件时自动选用
   * def.render(ctx) -> Node；ctx = { submitted, repaint, err(key) }
   * def.errors()    -> [{key, msg}]，提交时由 registry 统一调用
   * def.solo        独立组件（不与头部组合，如柴发并机测试）：无权限 / 离线未上传的提示由本组件自行报告
   */
  biz.part = function (def) {
    var st = { el: null, submitted: false, off: null };
    var errMap = {};
    function ctx() {
      return {
        submitted: st.submitted,
        repaint: paint,
        err: function (k) {
          return errMap[k];
        },
      };
    }
    function paint() {
      if (!st.el) return;
      errMap = {};
      if (st.submitted)
        def.errors().forEach(function (e) {
          if (!errMap[e.key]) errMap[e.key] = e.msg;
        });
      MW.mount(st.el, def.render(ctx()));
    }
    var part = {
      name: def.name,
      title: def.title || def.name,
      middle: def.middle || null,
      fold: def.fold || null,
      el: null,
      lastErrors: [],
      /** 平台初始值加载完成前展示骨架屏 */
      placeholder: function (el) {
        el.innerHTML = '<div class="mw-skeleton"><i></i><i></i><i></i></div>';
      },
      mount: function (el) {
        st.el = part.el = el;
        el.classList.add("mw-part", "mw-part--" + def.name);
        st.mark = function (e) {
          var k = MW.anchor.mark(e.target);
          if (k && !biz.isClosed()) biz.saveAnchor(k);
        };
        el.addEventListener("pointerdown", st.mark, true);
        el.addEventListener("focusin", st.mark, true);
        paint();
        st.off = store.on("*", function (changed) {
          // 多人同步只改了检查清单的部分步骤时，由组件自行局部重画
          var info = MW.sync && MW.sync.partial;
          if (info && def.partial && changed.every(function (k) { return info.keys.indexOf(k) > -1; })) {
            if (def.partial(ctx(), info, st.el)) return;
          }
          paint();
        });
        def.mounted && def.mounted(el);
        if (def.fold && MW.onFoldChange) MW.onFoldChange();
      },
      unmount: function () {
        st.off && st.off();
        st.off = null;
        if (st.el && st.mark) {
          st.el.removeEventListener("pointerdown", st.mark, true);
          st.el.removeEventListener("focusin", st.mark, true);
        }
        def.unmounted && def.unmounted();
        st.el = part.el = null;
      },
      /** 定位前让组件展开包含该 key 的区域（如已折叠的步骤）；有变化时返回 true */
      reveal: function (key) {
        return !!(st.el && def.reveal && def.reveal(key));
      },
      validate: function () {
        if (biz.isEnded()) return (part.lastErrors = []);
        if (biz.noPerm()) {
          part.lastErrors = def.name === "header" || def.solo ? [{ key: "_perm", section: part.title, perm: true, msg: biz.permText() }] : [];
          return part.lastErrors;
        }
        st.submitted = true;
        var list = def.errors().map(function (e) {
          return Object.assign({ section: part.title }, e);
        });
        // 还有离线暂存的操作没上传时不允许提交（由头部统一报一次）
        var off = (def.name === "header" || def.solo) && MW.sync && MW.sync.pending ? MW.sync.pending() : 0;
        if (off) list.unshift({ key: "_offline", section: part.title, offline: off, msg: "还有 " + off + " 项离线操作未上传" });
        part.lastErrors = list;
        paint();
        return list;
      },
      repaint: paint,
    };
    MW.registry.register(part);
    MW.parts = MW.parts || {};
    MW.parts[def.name] = part;
    MW.partList = MW.registry.list;
    return part;
  };

  /* ---------- 操作权限：仅当前待办处理人与流程管理员可操作组件 ----------
   * 1. 打开时先按平台带出的待办处理人（$context.processUsers）判断：是处理人立即可操作
   * 2. 不是处理人时先只读，向后端 get_operate_perm 确认是否为流程管理员（结果按 待办+账号 缓存在本机）
   * 3. 无网络且本机无缓存时保持只读，联网后自动重试；后端无法判定时放行（后端写入接口另有兜底校验）
   */
  var PERM_TTL = 7 * 24 * 3600 * 1000;
  var perm = { state: "", role: "", msg: "", checking: false, lastCheck: 0 };
  function normUser(u) {
    return String(u || "").replace(/\(.*?\)/g, "").trim();
  }
  function processUsers() {
    var p = biz.ctx().processUsers;
    var arr = Array.isArray(p) ? p : String(p || "").split(/[;,]/);
    return arr.map(normUser).filter(Boolean);
  }
  function permKey() {
    var c = biz.ctx();
    return "mw_perm:" + (c.taskId || "") + ":" + normUser(c.user);
  }
  function readPermCache() {
    try {
      var o = JSON.parse(localStorage.getItem(permKey()) || "null");
      if (o && Date.now() - o.t < PERM_TTL) return o;
    } catch (e) {}
    return null;
  }
  function writePermCache(o) {
    try { localStorage.setItem(permKey(), JSON.stringify(Object.assign({ t: Date.now() }, o))); } catch (e) {}
  }
  function setPerm(state, role, msg) {
    var changed = perm.state !== state || perm.msg !== (msg || "");
    perm.state = state;
    perm.role = role || "";
    perm.msg = msg || "";
    if (changed && MW.ready) store.touch();
  }
  function localPerm() {
    var me = normUser(biz.user()), users = processUsers();
    if (!me || !users.length) return { state: "ok", role: "" };
    if (users.indexOf(me) > -1) return { state: "ok", role: "dealer" };
    return readPermCache() || { state: "checking", role: "" };
  }
  /** 权限状态：ok 可操作 / deny 无权限 / checking 确认中 / offline 无网络无法确认 */
  biz.permState = function () {
    if (!perm.state) {
      var l = localPerm();
      perm.state = l.state;
      perm.role = l.role || "";
      perm.msg = l.msg || "";
    }
    return perm.state;
  };
  biz.noPerm = function () {
    if (biz.isEnded()) return false;
    return biz.permState() !== "ok";
  };
  biz.permText = function () {
    var me = normUser(biz.user()) || "-";
    var st = biz.permState();
    if (st === "checking") return "正在确认当前账号 " + me + " 的操作权限…";
    if (st === "offline") return "网络不可用，暂时无法确认账号 " + me + " 的操作权限，联网后自动重试";
    return perm.msg || "仅待办处理人或流程管理员可操作，当前账号 " + me + " 为只读";
  };
  /** 后端写入接口返回无权限（code -2）时调用：立即转为只读 */
  biz.permDenied = function (msg) {
    writePermCache({ state: "deny", role: "" });
    setPerm("deny", "", msg);
  };
  biz.permCheck = function (force) {
    if (biz.isEnded() || perm.checking) return Promise.resolve();
    var c = biz.ctx();
    if (!c.taskId || !normUser(c.user)) return Promise.resolve();
    if (!force && Date.now() - perm.lastCheck < 60000) return Promise.resolve();
    biz.permState();
    perm.checking = true;
    perm.lastCheck = Date.now();
    return api.call("get_operate_perm", {}).then(function (resp) {
      perm.checking = false;
      var r = resp && resp.data ? resp.data.result : null;
      if (r && r.known) {
        var st = r.allowed ? "ok" : "deny";
        writePermCache({ state: st, role: r.role || "" });
        setPerm(st, r.role);
      } else if (perm.state !== "ok") {
        // 后端无法判定（待办已不在运行表 / 查询异常 / 旧版后端）：与后端兜底一致，放行
        setPerm("ok", perm.role);
      }
    }, function (e) {
      perm.checking = false;
      perm.lastCheck = 0;
      if (util.isNetErr(e)) {
        if (perm.state === "checking") setPerm("offline");
      } else if (perm.state !== "ok" && perm.state !== "deny") {
        setPerm("ok", perm.role);
      }
    });
  };
  /** 引擎启动后调用：首次确认权限，并在联网 / 切回页面时重新确认 */
  biz.permInit = function () {
    if (biz.isEnded()) return;
    biz.permCheck(true);
    var unNet = MW.net.on(function (off) { if (!off) biz.permCheck(true); });
    function onVisible() { if (document.visibilityState === "visible") biz.permCheck(); }
    document.addEventListener("visibilitychange", onVisible);
    MW.cleanups.push(function () {
      unNet();
      document.removeEventListener("visibilitychange", onVisible);
    });
  };

  /** 必填判断（数组为空、空字符串、null 均视为未填写） */
  biz.req = function (list, key, value, msg) {
    if (util.isEmpty(value) || value === false) list.push({ key: key, msg: msg || "该字段是必填字段" });
  };

  /**
   * 头像：仅当账号是合法的英文名（EngName）时才拼 hr 头像地址，
   * 否则不出图（空账号会拼成 /photo/150/.png，触发资源加载错误）；
   * 加载失败（无头像 / 网络异常）时静默降级为账号首字母占位，不再向控制台抛资源错误
   */
  var AVATAR_RE = /^[A-Za-z][A-Za-z0-9_.-]*$/;
  biz.avatarUrl = function (user) {
    var u = typeof user === "string" ? user.trim() : "";
    return AVATAR_RE.test(u) ? "https://r.hrc.woa.com/photo/150/" + encodeURIComponent(u) + ".png?default_when_absent=true" : "";
  };
  /**
   * 返回头像节点；账号为空时返回 null。
   * 先渲染首字母占位，再用脱离 DOM 的 Image 预加载头像，加载成功才替换为 <img>；
   * 失败（外网/预览环境访问不到 r.hrc.woa.com、账号无头像等）时保持占位，
   * 页面内不会出现加载失败的 <img>，也就不会触发资源加载错误。结果按账号缓存，避免重复请求。
   */
  var avatarCache = {};
  biz.avatar = function (user) {
    var u = typeof user === "string" ? user.trim() : "";
    var url = biz.avatarUrl(u);
    if (!url) return null;
    var wrap = h("span", { class: "mw-avatar-wrap", title: u });
    function showImg() {
      wrap.innerHTML = "";
      wrap.appendChild(h("img", { class: "mw-avatar", src: url, alt: u }));
    }
    if (avatarCache[u] === true) { showImg(); return wrap; }
    wrap.appendChild(h("i", { class: "mw-avatar mw-avatar--ph", "aria-hidden": "true" }, u.charAt(0).toUpperCase()));
    if (avatarCache[u] === false) return wrap;
    var probe = new Image();
    probe.onload = function () { avatarCache[u] = true; showImg(); };
    probe.onerror = function () { avatarCache[u] = false; };
    probe.src = url;
    return wrap;
  };

  /* ================= 人脸识别 + 资质识别区块 ================= */
  /**
   * opts:
   *   suffix      ""（维护开始前）| "_end"（维护结束前）
   *   title       区块标题
   *   editable    是否可上传
   *   qualMethod  get_qualification（头部）| get_qualification_res（尾部）
   *   showDetail  是否展示 face_detail（原表单中隐藏）
   */
  biz.faceSection = function (opts) {
    var s = opts.suffix || "";
    var K = {
      user: "face_user" + s,
      photo: "face_photo" + s,
      time: "upload_face_photo_time" + s,
      result: "face_detect_result" + s,
      detail: "face_detail" + s,
      qual: "qualification_detect_result" + s,
      msg: "qualification_msg" + s,
    };
    // face_user 默认取当前处理人
    if (!store.get(K.user)) store.set(K.user, biz.user(), { silent: true });

    function faceDetect(list) {
      var unhold = MW.sync && MW.sync.on ? MW.sync.hold([K.photo, K.result, K.detail]) : function () {};
      store.set(K.result, biz.COMPARING);
      api.fre("face_detect", { img: list, deal_user: biz.user() }).then(function (resp) {
        var res = resp && resp.data ? resp.data.result : null;
        if (res && res.code == -1) {
          store.patch((function (o) { o[K.photo] = ""; o[K.result] = ""; return o; })({}));
          ui.alert(res.msg || "人脸识别失败", { title: "人脸识别" });
          return;
        }
        var r = (res && res.result) || {};
        var detect = r.detect_result;
        var identity = r.result && r.result.identity;
        var prob = r.result && r.result.probability;
        store.set(K.result, detect);
        if (detect) biz.inputUpdate(K.result, detect);
        var detail = "可能用户为：" + identity + "，可能性为：" + (prob * 100).toFixed(2) + "%";
        store.set(K.detail, detail);
        biz.inputUpdate(K.detail, detail);
      }).catch(function (e) {
        // 人脸识别必须由服务器给出结果：没网 / 失败时清空照片，恢复为可重新拍照
        var o = {};
        o[K.photo] = "";
        o[K.result] = "";
        store.patch(o);
        biz.inputUpdate(K.photo, "");
        if (util.isNetErr(e)) MW.offline.needNet("人脸识别");
        else ui.toast("人脸识别失败：" + (util.errMsg(e) || "服务异常") + "，请重新拍照", "warn");
      }).then(unhold, unhold);
    }

    function onChange(list) {
      store.set(K.photo, list);
      if (list.length && util.fileUrl(list[0])) {
        faceDetect(list);
        biz.inputUpdate(K.user, store.get(K.user));
      } else {
        biz.inputUpdate(K.user, "");
      }
      // 原逻辑：Upload 值为数组（含空数组）时均会记录时间并触发资质识别
      if (list) {
        biz.inputUpdate(K.photo, list);
        var t = util.now();
        store.set(K.time, t);
        biz.inputUpdate(K.time, t);
        api.fre(opts.qualMethod, { deal_user: store.get(K.user) }).then(function (resp) {
          var r = (resp && resp.data && resp.data.result) || {};
          var o = {};
          o[K.qual] = r.res;
          if (r.code != 1) o[K.msg] = r.msg;
          store.patch(o);
          if (s === "_end") {
            biz.inputUpdate(K.qual, r.res);
            biz.inputUpdate(K.msg, r.msg);
          }
        }).catch(function (e) {
          console.warn("[mw] 资质识别失败", e);
        });
      } else {
        store.set(K.time, biz.PHOTO_TIME_EMPTY);
      }
    }

    var result = store.get(K.result);
    var comparing = result === biz.COMPARING;
    var qual = store.get(K.qual);
    var photo = store.get(K.photo);
    var hasPhoto = Array.isArray(photo) && photo.length > 0;

    function resultTag() {
      if (util.isEmpty(result)) return ui.tag("待识别", "muted", "ri-time-line");
      if (comparing) return ui.tag("比对中，请勿提交", "warn", "ri-loader-4-line mw-spin");
      if (result === "比对成功") return ui.tag("比对成功", "ok", "ri-shield-check-fill");
      return ui.tag(result, "danger", "ri-shield-cross-fill");
    }
    function qualTag() {
      if (util.isEmpty(qual)) return ui.tag("待识别", "muted", "ri-time-line");
      return qual === "不匹配" ? ui.tag("不匹配", "danger", "ri-close-circle-fill") : ui.tag(qual, "ok", "ri-award-fill");
    }

    return h(
      "div",
      { class: ["mw-face", comparing && "is-comparing", opts.cls] },
      h("div", { class: "mw-face__title" }, h("i", { class: "ri-user-smile-line" }), h("h3", null, opts.title)),
      h(
        "div",
        { class: "mw-face__body" },
        h(
          "div",
          { class: "mw-face__shot" },
          ui.field(
            { label: "拍照上传", required: true, key: K.photo, error: opts.errors && opts.errors[K.photo], desc: opts.editable ? null : opts.lockTip },
            ui.upload({ value: hasPhoto ? photo : [], maxCount: 1, accept: "image/*", capture: "user", hero: true, text: "点击此处拍照", hint: "将调起前置摄像头，请拍摄本人清晰正脸", icon: "ri-camera-3-line", disabled: !opts.editable || comparing, needNet: "人脸识别", onChange: onChange })
          )
        ),
        h(
          "div",
          { class: "mw-face__info" },
          h("div", { class: "mw-kv" }, h("span", null, "当前处理人"), h("b", null, biz.avatar(store.get(K.user)), store.get(K.user) || "—")),
          h("div", { class: "mw-kv" }, h("span", null, "照片上传时间"), h("b", { class: util.isEmpty(store.get(K.time)) || /记录照片上传时间/.test(store.get(K.time)) ? "is-muted" : "" }, store.get(K.time) || "【上传照片】记录照片上传时间")),
          h("div", { class: "mw-kv" }, h("span", null, "人脸识别结果"), resultTag()),
          opts.showDetail && store.get(K.detail) && h("div", { class: "mw-kv" }, h("span", null, "识别详情"), h("b", null, store.get(K.detail))),
          h("div", { class: "mw-kv" }, h("span", null, "资质识别结果"), qualTag()),
          qual === "不匹配" && h("div", { class: "mw-alert mw-alert--danger" }, h("i", { class: "ri-error-warning-fill" }), h("div", null, h("b", null, "资质不匹配原因："), store.get(K.msg) || "—"))
        )
      )
    );
  };

  /* ================= 扫码（Scanner） ================= */
  /** opts: number(解析出的设备编号), name(设备名), state("ok"|"fail"|""), disabled, onChange(code)
   *  只读展示扫码结果：界面只出现设备编号（DevC），二维码底层编码不落输入框、不可手改；
   *  手机端点击按钮调起扫码（企业微信 wx.scanQRCode），PC 等不支持的环境仅展示结果 */
  biz.scanner = function (opts) {
    var canScan = !!host.scan;
    var state = opts.state || "";
    var has = !util.isEmpty(opts.number);
    function scan() {
      if (opts.disabled || !canScan) return;
      Promise.resolve(host.scan()).then(
        function (code) {
          if (code) opts.onChange(code);
        },
        function (e) {
          var m = util.errMsg(e);
          if (m && !/cancel/i.test(m)) ui.toast("扫码失败：" + m, "danger");
        }
      );
    }
    return h(
      "div",
      { class: ["mw-scanner", state && "is-" + state, opts.disabled && "is-disabled"] },
      has
        ? h("div", { class: "mw-scanner__code", title: "扫码识别的设备编号（只读）" },
            h("b", null, opts.number),
            opts.name && h("small", null, opts.name))
        : h("div", { class: "mw-scanner__empty" }, h("i", { class: "ri-qr-code-line" }),
            h("span", null, canScan ? "点击右侧「扫码」扫描设备二维码" : "请在企业微信手机端打开工单扫码，此处展示扫描结果")),
      canScan
        ? h("button", { type: "button", class: "mw-scanner__btn", disabled: !!opts.disabled, onClick: scan, "aria-label": "扫码" },
            h("i", { class: "ri-qr-scan-2-line" }), h("span", null, has ? "重新扫码" : "扫码"))
        : h("span", { class: "mw-scanner__tip", title: "请在企业微信手机端打开工单执行扫码，本页仅展示扫描结果" }, h("i", { class: "ri-smartphone-line" }), h("span", null, "手机扫码"))
    );
  };

  /* ================= 工单头部公共区块（头部组件 / 独立组件共用） ================= */
  /** 顶部横幅：o = { icon, crumbs:[...], title, chips:[...] } */
  biz.hero = function (o) {
    var v = biz.v;
    var status = biz.ctx().ticketStatus || "OPEN";
    var stText = { END: ["已提交", "ri-checkbox-circle-line"], CANCEL: ["已取消", "ri-close-circle-line"] }[status] ||
      (biz.isClosed() ? ["只读", "ri-lock-line"] : ["处理中", "ri-loader-2-line"]);
    if (!/^(END|CANCEL)$/.test(status)) status = biz.isClosed() ? "readonly" : "open";
    var crumbs = [];
    (o.crumbs || []).filter(Boolean).forEach(function (c, i) {
      if (i) crumbs.push(h("i", { class: "ri-arrow-right-s-line" }));
      crumbs.push(h("span", null, c));
    });
    return h(
      "section",
      { class: ["mw-hero", o.cls] },
      h("div", { class: "mw-hero__bg" }),
      h(
        "div",
        { class: "mw-hero__top" },
        h("div", { class: "mw-hero__icon" }, h("i", { class: o.icon || "ri-tools-fill" })),
        h(
          "div",
          { class: "mw-hero__title" },
          h("div", { class: "mw-hero__crumbs" }, crumbs),
          h("h1", null, o.title || "维护工单"),
          h(
            "div",
            { class: "mw-hero__meta" },
            h("span", null, h("i", { class: "ri-hashtag" }), "子单 ", h("b", null, biz.ticketId() || "—")),
            h("span", null, h("i", { class: "ri-user-3-line" }), biz.user()),
            (v("plan_start_date") || v("plan_end_date")) && h("span", null, h("i", { class: "ri-calendar-line" }), (v("plan_start_date") || "") + " ~ " + (v("plan_end_date") || ""))
          )
        ),
        h(
          "div",
          { class: "mw-hero__badges" },
          h("span", { class: "mw-hero__status is-" + String(status).toLowerCase() }, h("i", { class: stText[1] }), stText[0]),
          (o.chips || []).map(function (c) { return h("span", { class: "mw-hero__chip" }, c || "—"); })
        )
      )
    );
  };

  /** 基础信息面板：F = [[名称, 变量名, 图标, 等宽?], ...] */
  biz.infoPanel = function (F, opts) {
    opts = opts || {};
    return ui.panel(
      { title: opts.title || "基础信息", icon: opts.icon || "ri-information-line", id: opts.id || "mw-basic" },
      h("div", { class: "mw-info-grid" },
        F.map(function (f) {
          return h("div", { class: "mw-info" }, h("i", { class: f[2] }), h("div", null, h("small", null, f[0]), h("b", { class: f[3] ? "is-mono" : null }, biz.v(f[1]) || "—")));
        }))
    );
  };

  /** 只读提示：无权限 / 确认权限中 / 工单已提交或取消 */
  biz.closedBanner = function () {
    if (!biz.isClosed()) return null;
    if (!biz.isEnded()) {
      var ps = biz.permState();
      return h("div", { class: ["mw-alert", ps === "deny" ? "mw-alert--warn" : "mw-alert--info", "mw-closed", "mw-perm"] },
        h("i", { class: ps === "checking" ? "ri-loader-4-line mw-spin" : ps === "offline" ? "ri-wifi-off-line" : "ri-shield-user-line" }),
        h("div", null, h("b", null, ps === "deny" ? "无操作权限" : "只读"), "：", biz.permText(), ps === "deny" ? "。如需处理请联系流程管理员转派待办。" : ""));
    }
    var st = biz.ctx().ticketStatus;
    var end = st === "END", cancel = st === "CANCEL";
    return h("div", { class: ["mw-alert", cancel ? "mw-alert--danger" : end ? "mw-alert--ok" : "mw-alert--info", "mw-closed"] },
      h("i", { class: cancel ? "ri-close-circle-fill" : end ? "ri-checkbox-circle-fill" : "ri-lock-line" }),
      h("div", null, h("b", null, cancel ? "工单已取消" : end ? "工单已提交" : "当前待办不可编辑"), "，以下内容为只读状态。"));
  };

  /** 开关行：左侧标题+时间，右侧开关（头部开始维护 / 中部步骤开关 / 尾部确认完成 共用） */
  biz.switchRow = function (o) {
    return h(
      "div",
      { class: ["mw-swrow", o.value && "is-on", o.disabled && "is-disabled", o.error && "has-error", o.cls], dataset: o.key ? { key: o.key } : null },
      h("div", { class: "mw-swrow__icon" }, h("i", { class: o.icon || "ri-play-circle-line" })),
      h(
        "div",
        { class: "mw-swrow__main" },
        h("b", null, o.required && h("i", { class: "mw-req" }, "*"), o.title),
        h("span", { class: ["mw-swrow__time", !o.value && "is-muted"] }, o.time),
        o.tip && h("small", { class: "mw-swrow__tip" }, h("i", { class: "ri-lock-line" }), o.tip),
        o.error && h("small", { class: "mw-field__error" }, h("i", { class: "ri-error-warning-fill" }), o.error)
      ),
      ui.switch({ value: o.value, disabled: o.disabled, loading: o.loading, onChange: o.onChange, size: "lg" })
    );
  };
}
